<template>
  <ExTable :dataSource="dataSource">
    <DxEditing
        :allow-adding="true"
        :allow-deleting="true"
        :allow-updating="true"
        mode="form"
    />
  </ExTable>
</template>
<script>
import ExTable from "@/views/components/ExTable.vue";
import {DxColumn, DxEditing} from "devextreme-vue/data-grid";
import {$ctx} from "@themeConfig";

export default {
  components: {
    DxColumn,
    DxEditing,
    ExTable
  },
  data() {
    return {
      dataSource: {
        store: {
          type: "odata",
          version: 4,
          url: $ctx.API_URL + "odata.svc/" + this.$route.params.type,
          beforeSend: e => {
            e.headers = {
              apiKey: localStorage.getItem("accessToken")
            };
          }
        }
      }
    };
  },
  watch: {
    $route(n, o) {
      this.dataSource = {
        store: {
          type: "odata",
          version: 4,
          url: $ctx.API_URL + "odata.svc/" + n.params.type,
          beforeSend: e => {
            e.headers = {
              apiKey: localStorage.getItem("accessToken")
            };
          }
        }
      };
    }
  }
};
</script>
<style>
#gridContainer {
  height: 80vh;
}
</style>
